import React from "react"
import styled from "styled-components"
import { footerData } from "./ehi-footer_data";

const Footer = styled.div``

const basicStaticURL = `https://static.${process.env.GATSBY_SUBDOMAIN ||
""}ehealthinsurance.com`;

export default ({ pathname }) => {
    
    return (
        <Footer className="amp-footer-wrapper">
            <div className="container amp-footer">
            {footerData.map((footerItem, index) =>
                <div className="amp-footer__item" key={index}>
                    <h6 aria-level="2" className="footer-category__name h6">{footerItem.name}</h6>
                    <div className="footer-category__box">
                        <div>
                            <ul className="footer-category__list">
                            {footerItem.links.map((link, index) =>
                                <li key={index}>
                                    <a className="footer-category__link h6"
                                        data-wa-link={link['data-wa']}
                                        href={link.url}
                                        dangerouslySetInnerHTML={{
                                            __html: `${link.text}`}}></a>
                                </li>
                            )}
                            </ul>
                            { (footerData.length - 1) === index ? <div className="live-person-section footer">
                                <a className="button-primary" href={pathname}>Start Chat</a>
                            </div> : ''}
                        </div>
                        {footerItem.logos ? <ul className="footer-category__list footer-category__logos">
                            {footerItem.logos.map((link, index) =>
                                <li key={index}>
                                    {link.type === 'truste' ? <amp-iframe id="truste-amp-iframe"
                                        title="Truste"
                                        width="80"
                                        height="25"
                                        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                                        frameborder="0"
                                        src={`${basicStaticURL}/resources/amp-iframe-content/truste.html`}>
                                            <div overflow="true" tabIndex="0" role="button" aria-label="">Read more...</div>
                                    </amp-iframe> : <a
                                        className="footer-category__link h6"
                                        target="_blank"
                                        data-wa-link={link['data-wa']}
                                        href={link.url}
                                        dangerouslySetInnerHTML={{
                                            __html: `${link.text}`}}></a>}
                                </li>
                            )}
                        </ul> : ''}
                    </div>
                </div>
            )}
            
            </div>
        </Footer>
    )
}
